export default {"src":"/_next/static/media/gnosis-color.c687618f.svg","height":143,"width":144,"blurWidth":0,"blurHeight":0};